export default __webpack_public_path__ + "static/media/redshadowsofxotli.1980a9bf.png";